// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Constructor, EntityState, EntityStore, getEntityType, getIDType, StoreConfigOptions } from '@datorama/akita';
import { findDuplicatesById } from '@y42/util/find-duplicates-by-id';

export class Y42EntityStore<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  S extends EntityState = any,
  EntityType = getEntityType<S>,
  IDType = getIDType<S>,
> extends EntityStore<S, EntityType, IDType> {
  constructor(initialState?: Partial<S>, options?: Partial<StoreConfigOptions>) {
    super(initialState, options);
  }

  override upsertMany(
    entities: Array<getEntityType<S>>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options?: { baseClass?: Constructor<any> | undefined; loading?: boolean | undefined } | undefined,
  ): void {
    const duplicates = findDuplicatesById(entities, this.idKey);
    if (duplicates.length) {
      console.error(`Y42EntityStore.upsertMany: Found duplicates '${duplicates}'`);
    }

    return super.upsertMany(entities, options);
  }
}
